(function () {
  if (window.__noralInit) return;
  window.__noralInit = true;

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Carrito ---------- */
  function addItems(items, code, button, message) {
    var R = window.routes || {};
    var addUrl = (R.cart_add_url || '/cart/add') + '.js';
    var cartUrl = R.cart_url || '/cart';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (button) button.disabled = true;
    if (message) message.hidden = true;
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-to-cart');
      if (code) return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
    }).then(function () {
      window.location.href = cartUrl;
    }).catch(function () {
      if (message) {
        message.textContent = 'No se ha podido añadir al carrito. Inténtalo de nuevo.';
        message.hidden = false;
      }
      if (button) button.disabled = false;
    });
  }

  /* ---------- Packs y regalos ---------- */
  function updateGifts(root) {
    var checked = root.querySelector('input[name="noral-pack"]:checked');
    var qty = checked ? Number(checked.value) : 1;
    $all(root, '.nb__gift').forEach(function (g) {
      var unlocked = qty >= Number(g.getAttribute('data-gift-for')) + 1;
      if (unlocked && !g.classList.contains('is-unlocked')) {
        void g.offsetWidth;
        g.classList.add('is-unlocked');
      } else if (!unlocked) {
        g.classList.remove('is-unlocked');
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.name !== 'noral-pack') return;
    var root = e.target.closest('[data-noral-bundles]');
    if (root) updateGifts(root);
  });

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-noral-add]');
    if (button) {
      var root = button.closest('[data-noral-bundles]');
      var checked = root.querySelector('input[name="noral-pack"]:checked');
      if (!checked) return;
      var option = checked.closest('.nb__opt');
      var counts = {};
      function add(id) { if (id) counts[id] = (counts[id] || 0) + 1; }
      $all(option, '[data-noral-variant]').forEach(function (el) { add(el.value); });
      (option.getAttribute('data-gifts') || '').split(',').forEach(add);
      $all(root, '[data-noral-upsell]:checked').forEach(function (el) { add(el.value); });
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      addItems(items, option.getAttribute('data-code'), button, root.querySelector('[data-noral-message]'));
      return;
    }
    var sticky = e.target.closest('[data-noral-sticky-add]');
    if (sticky) {
      var bar = sticky.closest('[data-noral-sticky]');
      var id = bar.querySelector('[data-noral-sticky-variant]').value;
      addItems([{ id: Number(id), quantity: 1 }], '', sticky, null);
    }
  });

  /* ---------- Barra fija de compra ---------- */
  function initSticky() {
    var bars = $all(document, '[data-noral-sticky]');
    if (!bars.length) return;
    var bar = bars[bars.length - 1];
    bars.forEach(function (b) { if (b !== bar && b.dataset.moved) b.remove(); });
    if (bar.dataset.moved) return;
    bar.dataset.moved = '1';
    document.body.appendChild(bar);
    function check() {
      var cta = document.querySelector('[data-noral-add]');
      if (!cta) return;
      bar.classList.toggle('is-visible', cta.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------- Galería ---------- */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    var track = g.querySelector('[data-ng-track]');
    var slides = $all(g, '.ng__slide');
    var thumbs = $all(g, '[data-ng-thumb]');
    var list = g.querySelector('[data-ng-tlist]');
    var current = 0;
    if (!track || !slides.length) return;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && list) list.scrollTo({ left: t.offsetLeft - list.offsetLeft - (list.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      $all(g, '.ng__slide video').forEach(function (v) { v.pause(); });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = g.querySelector('[data-ng-prev]');
    var next = g.querySelector('[data-ng-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    }, { passive: true });

    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 4) drag.moved = true;
      track.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      track.classList.remove('is-dragging');
      var target = current;
      if (dx < -40) target = current + 1;
      else if (dx > 40) target = current - 1;
      drag = null;
      go(Math.max(0, Math.min(slides.length - 1, target)));
    });
  }

  /* ---------- Carrusel de vídeos ---------- */
  function initVideos(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var track = el.querySelector('[data-nv-track]');
    var items = $all(track, '.nv__item');
    var dotsBox = el.querySelector('[data-nv-dots]');
    if (!items.length) return;

    function gap() { return parseFloat(getComputedStyle(track).columnGap) || 0; }
    function step() { return items[0].getBoundingClientRect().width + gap(); }
    function perView() { return Math.max(1, Math.round((track.clientWidth + gap()) / step())); }
    function pages() { return Math.max(1, items.length - perView() + 1); }
    function index() { return Math.round(track.scrollLeft / step()); }

    function renderDots() {
      dotsBox.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv__dot';
        b.setAttribute('aria-label', 'Ir al vídeo ' + (i + 1));
        b.dataset.i = i;
        dotsBox.appendChild(b);
      }
      updateDots();
    }
    function updateDots() {
      var i = Math.min(index(), pages() - 1);
      $all(dotsBox, '.nv__dot').forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    function goTo(i) {
      var max = pages() - 1;
      if (i > max) i = 0;
      if (i < 0) i = max;
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    dotsBox.addEventListener('click', function (e) {
      var d = e.target.closest('.nv__dot');
      if (d) goTo(Number(d.dataset.i));
    });
    var prev = el.querySelector('[data-nv-prev]');
    var next = el.querySelector('[data-nv-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(updateDots); }, { passive: true });
    window.addEventListener('resize', renderDots);
    renderDots();

    $all(el, 'video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      var item = v.closest('.nv__item');
      item.addEventListener('click', function () {
        if (v.paused) { v.play(); item.classList.remove('is-paused'); }
        else { v.pause(); item.classList.add('is-paused'); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !item.classList.contains('is-paused')) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!en.isIntersecting) {
              v.pause();
            }
          });
        }, { threshold: 0.4 }).observe(v);
      } else {
        v.play();
      }
    });
  }

  /* ---------- Antes / después ---------- */
  function initCompare(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var range = el.querySelector('.nba__range');
    var dragging = false;
    function set(p) {
      p = Math.max(0, Math.min(100, p));
      el.style.setProperty('--pos', p + '%');
      if (range) range.value = p;
    }
    function fromEvent(e) {
      var r = el.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
    });
    el.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) {
      el.addEventListener(n, function () { dragging = false; });
    });
    if (range) range.addEventListener('input', function () { set(Number(range.value)); });
    set(50);
  }

  function initAll(root) {
    root = root || document;
    $all(root, '[data-noral-bundles]').forEach(updateGifts);
    $all(root, '[data-ng]').forEach(initGallery);
    $all(root, '[data-nv]').forEach(initVideos);
    $all(root, '[data-nba]').forEach(initCompare);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
